/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, identity, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CommunicationAttachmentDto } from '../communications';
import { EDocDto, EDocMapper } from '../e-docs';
import { SalesFolderEdocSigningRequestDto } from './sales-folder-e-doc.dto';

@Injectable()
export class SalesFolderEDocRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  sendToSign(salesFolderId: ID, quoteId: ID, request: SalesFolderEdocSigningRequestDto): Observable<void> {
    return this.httpPut(
      `${this.bp}/leads/sales-folders/${salesFolderId}/quotations/${quoteId}/send-to-sign`,
      request,
      identity(),
      none());
  }

  getLog(salesFolderId: ID): Observable<EDocDto[]> {
    return this.httpGet(`${this.crm}/leads/sales-folders/${salesFolderId}/rfq-edocs`, arrayOf(EDocMapper));
  }

  getLinks(salesFolderId: ID, documentId: ID): Observable<CommunicationAttachmentDto[]> {
    return this.httpGet(`${this.crm}/leads/sales-folders/${salesFolderId}/rfq-edocs/${documentId}`, identity());
  }
}
